import { Icon } from '@/components/Icon';
import { Tag } from '@/components/badges';
import { Button } from '@/components/ui/button';

interface Props {
  /** Number of variables listed, once known. */
  count: number | undefined;
  onImport: () => void;
  onAdd: () => void;
}

export function EnvPageHeader({ count, onImport, onAdd }: Props) {
  return (
    <header className="enter flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">Environment variables</h1>
          {count !== undefined ? <Tag data-testid="env-count">{count} keys</Tag> : null}
        </div>
        <p className="mt-1 text-sm text-muted-foreground">Settings your app needs when it is built. A value set for an app overrides the project's, and a value for one environment overrides the general one.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" data-testid="env-import-open" onClick={onImport}>
          <Icon name="upload" size={18} />
          Import .env
        </Button>
        <Button data-testid="env-add" onClick={onAdd}>
          <Icon name="add" size={18} />
          Add variable
        </Button>
      </div>
    </header>
  );
}

export function ExpoBanner() {
  return (
    <p data-testid="env-expo-banner" className="enter flex items-start gap-2 rounded-lg border border-running/30 bg-running/10 px-3 py-2 text-[13px] text-foreground/90">
      <Icon name="info" size={18} className="mt-px shrink-0 text-running" />
      <span>
        <code className="font-mono">EXPO_PUBLIC_*</code> values are embedded in the client JavaScript bundle during compilation and are completely public, so they can <strong>never</strong> be secret.
      </span>
    </p>
  );
}
